import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/dizzy': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c137 0 248 111 248 248s-111 248-248 248-248-111-248-248 111-248 248-248zM248 456c110.3 0 200-89.7 200-200s-89.7-200-200-200-200 89.7-200 200 89.7 200 200 200zM214.2 238.1c-7.9 7.9-20.5 7.9-28.4 0.2l-17.8-17.8-17.8 17.8c-7.8 7.8-20.5 7.8-28.3 0-7.8-7.8-7.8-20.5 0-28.3l17.9-17.9-17.9-17.9c-7.8-7.8-7.8-20.5 0-28.3 7.8-7.8 20.5-7.8 28.3 0l17.8 17.8 17.9-17.9c7.8-7.8 20.5-7.8 28.3 0s7.8 20.5 0 28.3l-17.9 17.9 17.9 17.8c7.8 7.8 7.8 20.5 0 28.3zM374.2 145.9c7.7 7.8 7.7 20.4 0 28.2l-17.9 17.9 17.8 18c7.8 7.8 7.8 20.5 0 28.3-7.8 7.8-20.5 7.8-28.3 0l-17.8-17.8-17.8 17.8c-7.8 7.8-20.5 7.8-28.3 0-7.8-7.8-7.8-20.5 0-28.3l17.9-17.9-17.9-17.9c-7.8-7.8-7.8-20.5 0-28.3 7.8-7.8 20.5-7.8 28.3 0l17.8 17.8 17.9-17.8c7.8-7.8 20.5-7.8 28.3 0zM248 272c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/dizzy.js
// module id = 1721
// module chunks = 0